import * as React from 'react';
import {
  HStack,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';

export type StatTile = {
  label: string;
  value: number;
};

/**
 * Panel stats for the roster.
 *
 * Takes a list of tiles rather than fixed props, on purpose: team feedback
 * (Aug 2026) flagged that an Active / Inactive / Drop-off Risk engagement axis
 * will matter once there's a real signal to derive it from, and wants the
 * summary designed for that now even though it isn't shipping yet. A future
 * "At Risk: N" tile should be a data change here — one more entry in the
 * array the caller builds — not a rewrite of this component.
 *
 * Every tile should describe the *filtered* list, not the whole database —
 * the question being asked is "how big is what I'm looking at", and a total
 * that ignored the filters would quietly contradict the list underneath it.
 */
export const PanelStats = ({ stats }: { stats: StatTile[] }) => (
  <HStack gap={10} alignItems="flex-start">
    {stats.map((stat) => (
      <Stat key={stat.label} value={stat.value} label={stat.label} />
    ))}
  </HStack>
);

const Stat = ({ value, label }: { value: number; label: string }) => (
  <VStack gap={0} align="flex-start">
    <Text
      my={0}
      fontSize="3xl"
      fontWeight="semibold"
      color="secondary.500"
      lineHeight="shorter"
    >
      {value}
    </Text>
    <Text my={0} fontSize="sm" color="secondary.500" whiteSpace="nowrap">
      {label}
    </Text>
  </VStack>
);
